import { render, staticRenderFns } from "./AccreditationAgreed.vue?vue&type=template&id=7447700c&scoped=true"
import script from "./AccreditationAgreed.vue?vue&type=script&lang=js"
export * from "./AccreditationAgreed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7447700c",
  null
  
)

export default component.exports